// import api from '../../api/_analyse'
import api_config from '../../api/config/_user'


const state = () => ({
   authInfo: null,
   activeRole: null,
   usersMinimalist: [],

   auth_user: []
})

// getters
const getters = {
    authInfo: (state) =>{
        return state.authInfo
    },

    activeRole: (state) =>{
        return state.activeRole
    },

    usersMinimalist: (state) =>{
        return state.usersMinimalist
    },
    
    auth_user: (state) =>{
        return state.auth_user
    },
}

// mutations
const mutations = {
    SET_CREDENTIALS(state, authInfo) {
        state.authInfo = authInfo;
    },

    SET_ACTIVE_ROLE(state, activeRole){
        state.activeRole = activeRole
    },

    SET_USERS_MINIMALIST(state,usersMinimalist){
        state.usersMinimalist = usersMinimalist
    },

    SET_AUTH_USER(state, auth_user){
        state.auth_user = auth_user
    }
}

// actions
const actions = {

    login({commit}, data) {
        return new Promise((resolve, reject) =>{
            api_config.login(data).then(
                response => {
                    commit('SET_CREDENTIALS', response)
                    let roleToUse = null;
                    let defaultRole = null;
                    for (const role of response.roles || [])
                    {
                        if(role.pivot?.is_active === 1 || role.pivot?.is_active === true || role.pivot?.is_active === "1")
                        {
                            roleToUse = role;
                        }
                        if(role.pivot?.is_default === 1 || role.pivot?.is_default === true || role.pivot?.is_default === "1" )
                        {
                            defaultRole = role;
                        } 
                    }
                    commit('SET_ACTIVE_ROLE', roleToUse || defaultRole || response.roles?.[0] || null)
                    resolve(response)
                }, error => {
                    reject(error);
                }
            )
        })
    },

    switchRole({commit},{userId,roleId}){
        return new Promise( (resolve,reject) =>{
            api_config.updateActiveRole(userId,roleId).then(
                response => {
                    resolve(response)
                    commit('SET_ACTIVE_ROLE',response)
                    console.log(response)

                },error =>{
                    reject(error)
                }
            )
        }

        )
    },

    getUsersMinimalist({commit,dispatch}){
        return new Promise((resolve,reject) => {
            api_config.getMinimalUsersInfo().then(
                response => {
                    resolve(response)
                    commit('SET_USERS_MINIMALIST',response)
                    dispatch('getAssignedExamensToUsers',response)
                    console.log(response)
                },error => {
                    reject(error)
                }
            )
        })
    },

    getAuthUser({commit}, {user_id}) {
        return new Promise((resolve, reject) => {
            api_config.getAuthUser(user_id).then(
                response => {
                    resolve(response)
                    commit('SET_AUTH_USER', response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    saveCouponAuthorizedUsers({dispatch}, data) {
        return new Promise((resolve, reject) => {
            api_config.saveCouponAuthorizedUsers(data).then(
                response => {
                    dispatch
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },
}

export default {
  state,
  getters,
  actions,
  mutations
}
